module.exports = __webpack_public_path__ + "img/aea743dba488e4d00ed777af98828acc.png";